/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm0-12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zM29 30H3v-5.1c0-2.2 1.2-4.1 3.2-5.1 6.1-3 13.6-3 19.7 0 2 1 3.2 2.9 3.2 5.1V30zM5 28h22v-3.1c0-1.4-.8-2.7-2.1-3.3-5.5-2.8-12.4-2.8-17.9 0-1.2.6-2 1.9-2 3.3V28z"/>'
  }
})
